import React from "react"
import { useSearchParams } from "react-router-dom"
import DashboardLayoutv2 from "core/layouts/DashboardLayoutv2"
import { Head } from "core/components/seo"
import ConditionalLoader from "core/components/ConditionalLoader"
import Loader from "core/components/Loader"
import TableButton from "core/components/v2/TableButton"
import ArrowBack from "core/components/v2/ArrowBack"
import RecordedProgressMeetViewModel from "./RecordedProgressMeetViewModel"
import ProgressMeetViewModel from "./ProgressMeetViewModel"
import ProgressMeetSidebar from "./components/ProgressMeetSidebar"
export default function RecordedProgressMeetView() {
  const {
    navigate,
    fetchProgressMeetDetail,
    meetingId,
    progressMeetDetails,
    loading,
    formatDate,
    pastSession,
    filterSessions,
    allProgressMeet,
    getAllProgressMeets,
    onLectureClick,
    activeIndex,

    progressMeetList,
  } = RecordedProgressMeetViewModel()

  interface ProgressMeet {
    meeting_id: string
    session_timestamp?: number
    class_link?: string
  }

  React.useEffect(() => {
    if (true) {
      fetchProgressMeetDetail()
    }
  }, [meetingId])
  React.useEffect(() => {
    async function fetchProgressMeets() {
      await getAllProgressMeets()
    }
    fetchProgressMeets()
  }, [])

  React.useEffect(() => {
    if (allProgressMeet.length > 0) {
      filterSessions()
    }
  }, [allProgressMeet])

  return (
    <DashboardLayoutv2>
      <Head title="Session" />
      <ConditionalLoader isLoading={loading} loader={<Loader />}>
        <div className="space-y-4 p-6">
          <div className="flex items-center justify-between">
            <div className="flex flex-col gap-1">
              <h3 className="text-gray-600 text-[14px] font-inter font-semibold leading-normal">
                {progressMeetDetails?.chapter_name}
              </h3>
              <p className="text-gray-500 text-[14px] font-inter font-normal leading-normal">
                Date: {formatDate(progressMeetDetails?.session_timestamp)}{" "}
              </p>
            </div>
            <TableButton
              className="flex h-fit w-fit items-center justify-center gap-1"
              outlined
              onClick={() => navigate("/progress-meeting")}
            >
              <ArrowBack />
              <p className="text-sm font-medium">Go Back</p>
            </TableButton>
          </div>
          <div className="flex gap-6">
            <div className="w-[72%] space-y-6">
              <div className="h-calc((w-full)*0.5625) w-full">
                {progressMeetDetails?.video_id ? (
                  <iframe
                    title="Video"
                    className="aspect-video h-full w-full rounded"
                    src={`https://player.vimeo.com/video/${progressMeetDetails?.video_id}?h=${progressMeetDetails?.video_secret ?? "a1b2c3d4e5f"}`}
                    allow="autoplay; fullscreen; picture-in-picture"
                  />
                ) : (
                  <div className="flex aspect-video h-full w-full items-center justify-center font-medium">
                    <span>Video not available!</span>
                  </div>
                )}
              </div>
            </div>
            <div className="w-[28%]">
              <ProgressMeetSidebar
                {...{
                  lectures: pastSession,
                  activeIndex,
                }}
                onClick={onLectureClick}
              />
            </div>
          </div>
        </div>
      </ConditionalLoader>
    </DashboardLayoutv2>
  )
}
